(function () {
  new Swiper(".AwardsSlider.swiper-container", {
    slidesPerView: 1.2,
    roundLengths: true,
    navigation: {
      nextEl: ".AwardsSlider__nav .swiper-button-next",
      prevEl: ".AwardsSlider__nav .swiper-button-prev",
    },
    pagination: {
      el: ".AwardsSlider__pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      426: {
        slidesPerView: 2,
      },
      1126: {
        slidesPerView: 3,
      },
    },
  });
})();
